// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CheckboxCheckedComponent} from './CheckboxChecked.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCheckboxChecked = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CheckboxCheckedComponent/>
  </Icon>
));
